import styled from 'styled-components';
import { useForm } from 'react-final-form';
import UploadPreview from '../UploadPreview';
import Spinner from '../../StoraEnsoComponents/Spinner';
import { useUploadingMedia } from '../uploadingContext';
import Button from '../../StoraEnsoComponents/Button';

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;

  span {
    display: block;
    margin: 16px auto;
    font-size: 1.375rem;
  }
`;

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
`;

const Result = styled.div`
  padding: 16px 32px;
  margin: 0 auto;
  text-align: center;
  background-color: ${({theme, result}) => result === 'positive' ? theme.colors.positive_bg : theme.colors.negative_bg};
  margin-bottom: 2rem;

  @media screen and (min-width: 768px) {
    min-width: 600px;
  }
`;

function UploadProgress() {
  const {
    submitting,
    setSubmitted,
    submittingAction,
    setSubmittingAction,
    setUploadFiles,
    files,
    success,
    setError,
    setSuccess,
  } = useUploadingMedia();

  const { reset } = useForm();

  const handleResetWizard = () => {
    reset();
    setSubmitted(false);
    setSubmittingAction(null);
    setUploadFiles([]);
    setError(null);
    setSuccess(null);
  }

  return (
    <Wrapper>
      {submitting && (
        <SpinnerWrapper>
          <Spinner />
          <span>{submittingAction}</span>
        </SpinnerWrapper>
      )}

      {
        success && (
          <ResultWrapper>
            <Result result="positive">
              {success}
            </Result>
            <Button onClick={handleResetWizard}>Upload new file</Button>
          </ResultWrapper>
        )
      }
      <UploadPreview
        items={files}
        removeDisabled />
    </Wrapper>
  );
}

export default UploadProgress;